import { IRegisterResponseEntity } from '../../model/api/register';
import { IRegisterResponse } from '../../model/models/register';
import { CustomerMapper } from '../customer/customer.mapper';

export class RegisterMapper {
  static fromRegisterResponseEntity(entity: IRegisterResponseEntity): IRegisterResponse {
    return {
      customerProfile: CustomerMapper.fromCustomerEntity(entity.customerProfile),
      deviceToken: entity.deviceToken
    };
  }
}



// WEBPACK FOOTER //
// ./src/providers/register/register.mapper.ts